export type QrLoginSession = {
  verkey: string
  qrContent: string
  deepLink: string
  expiresIn: number
}

export type QrLoginTokens = {
  did: string
  handle: string
  accessJwt: string
  refreshJwt: string
  active: boolean
}

export type QrPollResult =
  | {status: 'pending'}
  | {status: 'ready'; tokens: QrLoginTokens}

export async function createQrSession(
  serviceUrl: string,
): Promise<QrLoginSession> {
  const res = await fetch(`${serviceUrl}/qr-login/session`)
  if (!res.ok) {
    throw new Error(`Failed to create QR login session (${res.status})`)
  }
  return res.json()
}

export async function pollQrSession(
  serviceUrl: string,
  verkey: string,
): Promise<QrPollResult> {
  const res = await fetch(
    `${serviceUrl}/qr-login/poll?verkey=${encodeURIComponent(verkey)}`,
  )
  if (res.status === 202) {
    return {status: 'pending'}
  }
  if (!res.ok) {
    throw new Error(`QR login failed (${res.status})`)
  }
  return {status: 'ready', tokens: await res.json()}
}
